import { useCallback, useState } from "react";
import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { ButtonActionProps } from "../../internal-components/Button.js";
import { useInterval } from "../../hooks/useInterval.js";
import { Constrainer } from "../../internal-components/Layout.js";
import {
  Slider,
  SlideWrapper,
  SlideButtons,
  SlideButton,
  Dots,
} from "./styles.js";
import { chevron } from "../../icons/index.js";
import { HeroSlide } from "./default.js";

interface Slide {
  title?: string;
  titleSize?: number;
  text?: string;
  image?: Image;
  mobileImage?: Image;
  actions?: ButtonActionProps[];
}

interface HeroSliderProps {
  slides: Slide[];
  autoplay?: boolean;
}

export const HeroSlider: React.FunctionComponent<HeroSliderProps> = ({
  slides,
  autoplay,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const handleSlideChange = useCallback(
    (prev?: boolean) => {
      setActiveIndex((current) => {
        if (prev) {
          return current === 0 ? slides.length - 1 : current - 1;
        }
        return current === slides.length - 1 ? 0 : current + 1;
      });
    },
    [slides.length]
  );

  useInterval(
    () => {
      if (autoplay) handleSlideChange();
    },
    7000,
    isHovered
  );

  return (
    <Constrainer>
      <Slider
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {slides.map((slide, i) => (
          <SlideWrapper
            key={i}
            className={i === activeIndex ? "active" : ""}
          >
            <HeroSlide {...slide} />
          </SlideWrapper>
        ))}
        {slides.length > 1 && (
          <SlideButtons>
            <SlideButton className="prev" onClick={() => handleSlideChange(true)}>
              {chevron}
            </SlideButton>
            <SlideButton className="next" onClick={() => handleSlideChange()}>
              {chevron}
            </SlideButton>
          </SlideButtons>
        )}
      </Slider>
      {slides.length > 1 && (
        <Dots
          dots={slides.map((_, i) => i)}
          active={activeIndex}
          setSlice={setActiveIndex}
        />
      )}
    </Constrainer>
  );
};
